import { call, put, select, takeLatest } from "redux-saga/effects";
import { notification } from "antd";
import { GET } from "../../api";
import ApiRouts from "../../api/routes";
import { FETCH_SINGLE_CATEGORY_FILE } from "../actions";
import { setSingleCategoryFile } from "./action";


const getCurrentPage = (state) => state.currentPage;


function* fetchSingleCategoryFileSaga(action) {


    const currentPage = yield select(getCurrentPage);


    try {
        const response = yield call(GET, `${ApiRouts.API_SINGLE_COLLECTION}/${action.payload.collectionId}/files-in-category/${action.payload.categoryId}?page=${currentPage.currentPage}`,);
        if (response) {
            yield put(setSingleCategoryFile(response.data));

        } else {
            throw new Error("Failed to fetch the banner.");
        }
    } catch (error) {
    }
}

function* singleCategoryFileSaga() {
    yield takeLatest(FETCH_SINGLE_CATEGORY_FILE, fetchSingleCategoryFileSaga);
}


export default singleCategoryFileSaga;
